import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ArtifactRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: ArtifactRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function ArtifactRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "artifact",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("ArtifactRegionTypeCard.title")}
      description={t("ArtifactRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
